import { registerPlugin } from "@capacitor/core";


export interface SworkitAppleWatchPlugin {
  initWatchTranslations(options: any): Promise<any>;
  initWatch(options: any, callback: any): void;
  syncWorkoutState(options: any): Promise<any>;
}
const SworkitAppleWatch = registerPlugin<SworkitAppleWatchPlugin>('SworkitAppleWatch');

export default SworkitAppleWatch;